module.exports = __webpack_public_path__ + "static/media/CustomerActiveIcon.ff2a50e4.svg";